import { createSlice } from '@reduxjs/toolkit';
import { filter } from 'lodash';
import Axios from '../../utils/axiosInstance';

const initialState = {
  cadMasterList: [],
  cad: null,
  cadMasterIdData: [],
  cadMasterId: null,
};

const slice = createSlice({
  name: 'cadmaster',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setWorkshopId: (state, action) => {
      state.cadMasterId = action.payload;
    },

    // DELETE cadMaster
    deleteCadMaster(state, action) {
      const deleteCadMaster = filter(state.cad, (cad) => cad.id !== action.payload);
      state.cad = deleteCadMaster;
    },

    // GET cadMaster
    getCadMasterListSuccess(state, action) {
      state.isLoading = false;
      state.cadMasterList = action.payload;
    },

    // Create cadMaster
    createCadMaster(state, action) {
      state.isLoading = false;
      state.cad = action.payload;
    },
    CadMasterFindByID(state, action) {
      state.isLoading = false;
      state.cadMasterIdData = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow, deleteCadMaster } = slice.actions;

// ----------------------------------------------------------------------

export function dispatchDeleteCadMaster(cadMasterId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await Axios.delete(`/cad-master/${cadMasterId}`);
      dispatch(slice.actions.deleteCadMaster(cadMasterId));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function dispatchNewCadMaster(cad) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.post('/cad-master', cad);
      dispatch(slice.actions.createCadMaster(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function dispatchUpdateCadMaster(id, cad) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.put(`/cad-master/${id}`, cad);
      dispatch(slice.actions.createCadMaster(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getCadMasterList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.get('/cad-master');
      dispatch(slice.actions.getCadMasterListSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------- cadMaster id find -------------------------------------

export function getCadMasterFindByID(id) {
  return async (dispatch) => {
    if (!id) return;

    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.get(`/cad-master/${id}`);
      dispatch(slice.actions.CadMasterFindByID(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
